/**
 * GENERATED by scripts/generate-asset-urls.mjs - do not edit by hand.
 *
 * The flat list of bundled .woff2 filenames, with NO `import.meta.url` (unlike asset-urls.ts).
 * The browser/IIFE entry (cdn-entry.ts) imports this to validate face files and to resolve them
 * relative to its own <script>, since import.meta.url is not available in an IIFE bundle.
 */
export const BUNDLED_FONT_FILES: readonly string[] = Object.freeze([
  'ArchivoBlack-Regular.woff2',
  'BacasimeAntique-Regular.woff2',
  'C059-BdIta.woff2',
  'C059-Bold.woff2',
  'C059-Italic.woff2',
  'C059-Roman.woff2',
  'Caladea-Bold.woff2',
  'Caladea-BoldItalic.woff2',
  'Caladea-Italic.woff2',
  'Caladea-Regular.woff2',
  'Caprasimo-Regular.woff2',
  'Cardo-Bold.woff2',
  'Cardo-Italic.woff2',
  'Cardo-Regular.woff2',
  'Carlito-Bold.woff2',
  'Carlito-BoldItalic.woff2',
  'Carlito-Italic.woff2',
  'Carlito-Regular.woff2',
  'ComicRelief-Bold.woff2',
  'ComicRelief-Regular.woff2',
  'Gelasio-Bold.woff2',
  'Gelasio-BoldItalic.woff2',
  'Gelasio-Italic.woff2',
  'Gelasio-Regular.woff2',
  'InconsolataSemiExpanded-Bold.woff2',
  'InconsolataSemiExpanded-Regular.woff2',
  'LiberationMono-Bold.woff2',
  'LiberationMono-BoldItalic.woff2',
  'LiberationMono-Italic.woff2',
  'LiberationMono-Regular.woff2',
  'LiberationSans-Bold.woff2',
  'LiberationSans-BoldItalic.woff2',
  'LiberationSans-Italic.woff2',
  'LiberationSans-Regular.woff2',
  'LiberationSansNarrow-Bold.woff2',
  'LiberationSansNarrow-BoldItalic.woff2',
  'LiberationSansNarrow-Italic.woff2',
  'LiberationSansNarrow-Regular.woff2',
  'LiberationSerif-Bold.woff2',
  'LiberationSerif-BoldItalic.woff2',
  'LiberationSerif-Italic.woff2',
  'LiberationSerif-Regular.woff2',
  'NotoSans-Bold.woff2',
  'NotoSans-BoldItalic.woff2',
  'NotoSans-Italic.woff2',
  'NotoSans-Regular.woff2',
  'NotoSansMono-Bold.woff2',
  'NotoSansMono-Regular.woff2',
  'OreganoItalic-Regular.woff2',
  'PTSans-Bold.woff2',
  'PTSans-BoldItalic.woff2',
  'PTSans-Italic.woff2',
  'PTSans-Regular.woff2',
  'PTSansNarrow-Bold.woff2',
  'PTSansNarrow-Regular.woff2',
  'Selawik-Bold.woff2',
  'Selawik-Regular.woff2',
  'TeXGyreBonum-Bold.woff2',
  'TeXGyreBonum-BoldItalic.woff2',
  'TeXGyreBonum-Italic.woff2',
  'TeXGyreBonum-Regular.woff2',
  'URWGothic-Book.woff2',
  'URWGothic-BookOblique.woff2',
  'URWGothic-Demi.woff2',
  'URWGothic-DemiOblique.woff2',
]);
